import React, { forwardRef } from 'react';
import { Grid, Typography, Paper } from '@mui/material';

const LabelSx = {
    marginTop: (theme) => theme.spacing(2),
    marginBottom: (theme) => theme.spacing(2),
};

const PaperLayout = forwardRef(({ children, label, spacing = 2, fieldCreatorProps, labelProps, ...rest }, ref) => {
    return (
        <Paper {...rest} ref={ref}>
            {label && (
                <Typography variant="h6" className="mt-16 mb-16" sx={LabelSx} {...labelProps}>
                    {label}
                </Typography>
            )}
            <Grid container spacing={spacing} alignItems="center">
                {children}
            </Grid>
        </Paper>
    );
});

export default PaperLayout;
